<template>
  <v-menu v-model="dialog" min-width="500px" offset-y :close-on-content-click="false">
    <template #activator="{ on }">
      <app-button class="mx-1" data-e2e-id="set-reminder-btn" v-on="on">Set Reminder</app-button>
    </template>
    <app-reminder-card ref="reminder" :title="title">
      <template #actions>
        <v-spacer></v-spacer>
        <app-button text @click="onClose">Cancel</app-button>
        <app-button data-e2e-id="reminder-dialog-set-reminder" @click="submit"
          >Set Reminder</app-button
        >
      </template>
    </app-reminder-card>
  </v-menu>
</template>

<script>
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import { reminderService } from '@/services/reminder-service'

export default {
  props: {
    config: { type: Object, required: true },
    title: { type: String, default: '' },
    type: { type: String, required: true }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    onClose() {
      this.$refs.reminder.resetForm()
      this.dialog = false
    },
    async submit() {
      const form = this.$refs.reminder.getReminder()
      if (form) {
        const reminder = {
          ...{
            tenantId: MyActiveOrganization.id,
            reminderType: this.type
          },
          ...this.config,
          ...form
        }
        await reminderService.create(reminder)
        this.dialog = false
        this.$refs.reminder.resetForm()

        this.$emit('create')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
col > * {
  padding: none;
}
</style>
